export const 
    AllNatural = require('./AllNatural.png'),
    EcoFriendly = require('./EcoFriendly.png'),
    NationallyRecognizedBrandLead = require('./NationallyRecognizedBrandLead.png'),
    SensitiveSkin = require('./SensitiveSkin.png'),
    SocialGood = require('./SocialGood.png'),
    SupplyDropPick = require('./SupplyDropPick.png'),
    Value = require('./Value.png')